import { render, staticRenderFns } from "./GroupTaskDetails.vue?vue&type=template&id=ac37625a&"
import script from "./GroupTaskDetails.vue?vue&type=script&lang=js&"
export * from "./GroupTaskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports